import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useStore, useTheme } from "@/comn/hooks";
import React, { useEffect } from "react";
import { APIS, SF_AUTH_SRCH, SG_SCRH_AUTH_LIST } from "@/tra/tancis/ptli/ptl/cstmauth/service/PtliCstmAuthService";

/*
 * Pop-up for Customs User Auth Registration
 * !== 세관 사용자 권한 등록을 위한 팝업  ==!
 */
export const PTLI1007003Q = (props: any): JSX.Element => {
    const { usrDmnId, cstmUsrAuthList, callback } = props;

    const modal = useModal();
    const { theme } = useTheme();
    const { pgeUid } = usePage({ pgeUid: "ptli1007003q" });

    const form = {
        authSrch: useForm({ defaultSchema: SF_AUTH_SRCH }),
    };

    const grid = {
        authList: useGrid({ defaultSchema: SG_SCRH_AUTH_LIST }),
    };

    const fetch = {
        getAuthList: useFetch({
            api: (page = grid.authList.page, size = grid.authList.size) =>
                APIS.getAuthList(form.authSrch.getValues(), page, size),
            enabled: true,
            key: [grid.authList.page, grid.authList.size],
            onSuccess: () => {},
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const handler = {
        onBtnApplyClick: () => {
            if (grid.authList.getChecked().length === 0) {
                modal.openModal({ content: "msg.com.00086" }); // No data has been selected.. !== 선택된 데이터가 없습니다. ==!
                return;
            }
            if (callback) callback(grid.authList.getChecked());
        },
        onBtnSrchClick: () => fetch.getAuthList.fetch(),
    };

    const render = {
        checkbox: (row: any) => {
            return row.isRgsrYn !== "Y" && cstmUsrAuthList.findIndex((item: any) => item.authId === row.authId) === -1;
        },
    };

    useEffect(() => {
        form.authSrch.setValue("usrDmnId", usrDmnId);
    }, [theme]);

    return (
        <Page pgeUid={pgeUid} info={true}>
            <Group>
                <Group.Body>
                    <Group.Section gap={2}>
                        <Group.Row>
                            <Group.Control {...form.authSrch.schema.authId} />
                            <Group.Control {...form.authSrch.schema.authNm} />
                        </Group.Row>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onBtnSrchClick} />
                        </Layout.Right>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section gap={2}>
                        <Grid {...grid.authList.grid} data={fetch.getAuthList.data?.authList} render={render} />

                        <Layout.Right>
                            <Button role={"apply"} onClick={handler.onBtnApplyClick} />
                        </Layout.Right>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
